import AnalysisFilter from 'types/analysisFilter'
import { InsightContentSettingType } from 'components/insightContent/types'
import { PopularLinksWidgetsType, PostMetricWithSoundbites } from '../../types'

import { toFilter } from '../../../../../utils/widgetUtil'

export const convertToInsightContentSetting = (
  widgetSetting: PopularLinksWidgetsType,
  selection?: PostMetricWithSoundbites
) => {
  const insightContentSetting = {
    viewOption: widgetSetting.viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const post = selection
  const filter = toFilter(widgetSetting)
  filter.mentionedUrls = []

  insightContentSetting.selectionName = post?.mentionedUrls?.[0]?.url || ''

  if (post?.mentionedUrls) {
    const mentionedUrl = post?.mentionedUrls[0]

    const url = {
      url: mentionedUrl.url
    }

    const displayUrl = {
      displayUrl: mentionedUrl.displayUrl
    }

    const expandedUrl = {
      expandedUrl: mentionedUrl.expandedUrl
    }

    filter.mentionedUrls?.push(url)
    filter.mentionedUrls?.push(displayUrl)
    filter.mentionedUrls?.push(expandedUrl)
  }
  insightContentSetting.selectionFilter = filter
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (widgetSetting: PopularLinksWidgetsType) => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    const convertedWidgetSetting = {} as PopularLinksWidgetsType

    const keys = Object.keys(widgetSetting) as Array<keyof PopularLinksWidgetsType>

    keys.forEach((key) => {
      if (widgetSetting[key] != null) {
        // @ts-ignore
        convertedWidgetSetting[key] = widgetSetting[key]!
      }
    })
    return convertedWidgetSetting
  }
  return {}
}
